import React from 'react'
import { SiteLayout } from '../components/Layout'
import PhaseEBookIndustry from '../components/CaresOvervieweBookDownloadPage/PhaseEBookIndustry'
import PhaseEBookFeaturedWork from '../components/CaresOvervieweBookDownloadPage/PhaseEBookFeaturedWork'
import { graphql } from 'gatsby'
import Seo from '../components/seo'
import Phase4EBookBanner from '../components/CaresOvervieweBookDownloadPage/Phase4EBookBanner'
import OvercomeChallenges from '../components/CaresOvervieweBookDownloadPage/OvercomeChallenges'
import CareseBook from '../components/CaresFremworkPage/CareseBook'

const Phase4eBookDownload = ({ data, path, pageContext }: any) => {
  return (
    <SiteLayout path={path} pageId={pageContext?.databaseId}>
      <Phase4EBookBanner data={data?.tsPage?.flexibleContent?.flexibleContent[0]} />
      <OvercomeChallenges  data={data?.tsPage?.flexibleContent?.flexibleContent[4]} />
      <PhaseEBookIndustry
        data={data?.tsPage?.flexibleContent?.flexibleContent[1]}
        sectionCount="01"
      />
      <CareseBook data={data?.tsPage?.flexibleContent?.flexibleContent[3]} />
      <PhaseEBookFeaturedWork
        data={data?.tsPage?.flexibleContent?.flexibleContent[2]}
        sectionCount="02"
      />
    </SiteLayout>
  )
}

export const Phase4eBookDownloadquery = graphql`
  query MyQuery($databaseId: Int) {
    tsPage(databaseId: { eq: $databaseId }) {
      ...seo
      id
      databaseId
      title
      flexibleContent {
        flexibleContent {
          ... on tsPage_Flexiblecontent_FlexibleContent_MvpPagesBanner {
            heading
            subHeading
            content
            contentsLists
            formSection {
              formTitle
            }
          }
          ... on tsPage_Flexiblecontent_FlexibleContent_ChallengesToOvercome {
            lineHeading
            lineNumber
            heading
            content
            downloadButton {
              title
              url
              target
            }
          }
          ... on tsPage_Flexiblecontent_FlexibleContent_MvpDevelopment {
            lineHeading
            heading
            content
            cta {
              title
              url
              target
            }
            technologyIcons {
              altText
              mediaItemUrl
            }
          }
          ... on tsPage_Flexiblecontent_FlexibleContent_CoreSpecialtiesSection {
            lineHeading
            lineNumber
            content
            coreSpecialtiesPages {
              ... on tsPage {
                slug
                title
                link
                featuredImage {
                  node {
                    altText
                    mediaItemUrl
                  }
                }
              }
            }
          }
          ... on tsPage_Flexiblecontent_FlexibleContent_FeaturedWorkSection {
            backgroundColor
            needBackgroundColor
            needLine
            lineHeading
            lineNumber
            heading
            content
            featuredWorks {
              ... on tsCaseStudy {
                title
                link
                slug
                caseStudyCategories {
                  nodes {
                    name
                    link
                    slug
                  }
                }
                featuredImage {
                  node {
                    altText
                    mediaItemUrl
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;

export default Phase4eBookDownload


export const Head = ({ data, location }: any) => {
    return (
      <Seo
        seoData={data?.tsPage?.seo}
        authorData={data?.tsPage?.author}
        children={undefined}
        Pageid={data?.tsPage?.databaseId}
        path={location}
        featureImage={undefined}
      />
    );
  };